__turbopack_context__.v({
  "card": "_02PtQq_card",
  "content": "_02PtQq_content",
  "definition": "_02PtQq_definition",
  "term": "_02PtQq_term",
});
